export default function sanitizeString(countryName) {
  return countryName
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[- '()]/g, '')
    .toLowerCase();
}
